import { getDefaultClient } from '@dynamic-labs-sdk/client';
import { getWalletProviderFromWalletAccount } from '@dynamic-labs-sdk/client/core';
import type { Transaction } from '@mysten/sui/transactions';

import { NotSuiProviderError } from '../errors/NotSuiProviderError';
import { isSuiWalletProvider } from '../isSuiWalletProvider';
import type { SuiWalletAccount } from '../SuiWalletAccount.types';
import type { SuiSignAndExecuteTransactionResult } from '../SuiWalletProvider.types';

type SignAndExecuteTransactionParams = {
  transaction: Transaction;
  walletAccount: SuiWalletAccount;
};

/**
 * Signs and executes a Sui transaction
 * @param params.transaction - The transaction to sign and execute
 * @param params.walletAccount - The wallet account to sign the transaction with
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns An object containing the signature and transaction bytes
 */
export const signAndExecuteTransaction = async (
  { walletAccount, transaction }: SignAndExecuteTransactionParams,
  client = getDefaultClient()
): Promise<SuiSignAndExecuteTransactionResult> => {
  const provider = getWalletProviderFromWalletAccount(
    {
      walletAccount,
    },
    client
  );

  if (!isSuiWalletProvider(provider)) {
    throw new NotSuiProviderError({ providerKey: provider.key });
  }

  transaction.setSender(walletAccount.address);

  return provider.signAndExecuteTransaction({ transaction, walletAccount });
};
